module.exports = __webpack_public_path__ + "64da191f3f8e4ee1dd5d0dfb441e3e7c.png";